import { Box, Button, debounce, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material"
import { useAppSelector } from "../../../../../../../../hooks/store-hooks"
import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles"

export const CreateListaCidadesForm = (props: {
    openForm: boolean
}) => {
    // State
    const { listaCidades } = useAppSelector((state) => state)
    // Hook
    const {
        openCreateListaCidadesForm,
        setCreateListaCidadesName,
        createListaCidades
    } = useListaCidadesService()

    return (
        <>
            {
                props.openForm === true &&
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={listaCidades.openCreateListaCidades}
                    onClose={() => {
                        openCreateListaCidadesForm(false)
                    }}
                >
                    <DialogTitle>
                        Criar nova lista de Cidades
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Escolha um nome para a lista de Cidades
                        </DialogContentText>
                        <Box my={3}>
                            <TextField
                                error={Boolean(listaCidades.createListaCidadesForm.touched && listaCidades.createListaCidadesForm.errors.find(item => item.key === 'nome'))}
                                helperText={listaCidades.createListaCidadesForm.errors.find((error) => error.key === 'nome')?.message}
                                defaultValue={listaCidades.createListaCidadesForm.fields.nome}
                                onChange={debounce((e) => {
                                    setCreateListaCidadesName(e.target.value)
                                }, 500)}
                                autoFocus
                                id="nomeproj"
                                label="Digite o nome da lista de Cidades"
                                fullWidth
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                openCreateListaCidadesForm(false)
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={() => {
                                createListaCidades()
                            }}
                        >
                            Criar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}